import PlanningRdvCard from './PlanningRdvCard';
import { intervenantDisplayName } from '../../utils/planningDayParis';
import { UNASSIGNED_KEY } from './PlanningDayTimeline';

export default function PlanningMobileList({
  rdvs,
  memberByInstructeurId,
  onRdvClick,
  loading = false,
  showParticularityIndicator = false,
}) {
  if (loading) {
    return (
      <div className="flex h-48 items-center justify-center rounded-2xl border border-gray-100 bg-white">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-violet-600" />
      </div>
    );
  }

  if (!rdvs?.length) {
    return (
      <div className="rounded-2xl border border-dashed border-gray-200 bg-white px-5 py-12 text-center">
        <p className="text-sm font-medium text-gray-700">Aucun rendez-vous ce jour</p>
        <p className="mt-1 text-xs text-gray-500">Changez de date ou élargissez les filtres.</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {rdvs.map((rdv) => {
        const member = rdv.instructeurId
          ? memberByInstructeurId[rdv.instructeurId]
          : null;
        const label = member
          ? intervenantDisplayName(member)
          : rdv.instructeur
            ? intervenantDisplayName(rdv.instructeur)
            : rdv.instructeurId
              ? 'Intervenant'
              : 'Non assigné';
        return (
          <PlanningRdvCard
            key={rdv.id}
            rdv={rdv}
            onClick={onRdvClick}
            showIntervenant
            intervenantLabel={label}
            showParticularityIndicator={showParticularityIndicator}
          />
        );
      })}
    </div>
  );
}

export function resolveIntervenantKey(rdv) {
  return rdv?.instructeurId || UNASSIGNED_KEY;
}
